import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { setFormData, updateFormData } from "../../redux-store/formDataSlice";

const bg = `${EASYCOMMERCE.assets}admin/img/icons/bg.png`;
const visa = `${EASYCOMMERCE.assets}admin/img/icons/Visa.png`;
const mastercard = `${EASYCOMMERCE.assets}common/img/payment/Mastercard.png`;
const stripe = `${EASYCOMMERCE.assets}admin/img/icons/Stripe.png`;

const paymentMethodImages = {
    visa: visa,
    mastercard: mastercard,
    stripe: stripe,
};
const Store = () => {
    const dispatch = useDispatch();
    const storeData = useSelector((state) => state.formData);

    useEffect(() => {
        fetch(`${EASYCOMMERCE.rest_base}/connectivity/setup/get`, {
            method: "GET",
            headers: {
                "Content-Type": "application/json",
                "X-WP-Nonce": EASYCOMMERCE.nonce,
            },
        })
            .then((res) => res.json())
            .then((data) => {
                if (data.success && data?.data?.data) {
                    dispatch(setFormData(data.data.data));
                }
            });
    }, []);
    

    return (
        <div
            className="bg-cover bg-center w-full flex flex-col items-center"
            style={{
                backgroundImage: `url(${bg})`,
                backgroundSize: "1100px",
                backgroundRepeat: "no-repeat",
            }}
        >
            <div className="w-[40%] bg-[#FFFFFF] flex flex-col p-10 border-2 border-[#E0E8FF] rounded-xl">
                <div className="flex flex-col w-full space-y-6">
                    {/* Currency Selection */}
                    <div className="flex flex-col space-y-2">
                        <label className="text-ec-body text-[16px] font-medium">
                            Currency
                        </label>
                        <select
                            className="easycommerce-wizard-input w-full"
                            value={storeData.currency}
                            onChange={(e) =>
                                dispatch(
                                    updateFormData({
                                        key: "currency",
                                        value: e.target.value,
                                    })
                                )
                            }
                        >
                            <option value="">Select Your Currency</option>
                            {Object.keys(EASYCOMMERCE.currencies).map(
                                (currency) => (
                                    <option key={currency} value={currency}>
                                        {EASYCOMMERCE.currencies[currency]}
                                    </option>
                                )
                            )}
                        </select>
                        <p className="text-ec-placeholder text-xs">
                            Choose the currency you want to use.
                        </p>
                    </div>

                    {/* Payment Method */}
                    <div className="flex flex-col space-y-2">
                        <label className="text-ec-body text-[16px] font-medium mb-3">
                            Payment Method
                        </label>
                        <div className="space-y-4">
                            {Object.keys(EASYCOMMERCE.payment_methods).map(
                                (paymentMethod) => (
                                    <div
                                        key={paymentMethod}
                                        className="flex items-center p-2 space-x-2"
                                    >
                                        <input
                                            type="checkbox"
                                            id={paymentMethod}
                                            name="paymentMethod"
                                            value={paymentMethod}
                                            checked={storeData.payment_methods.includes(
                                                paymentMethod
                                            )}
                                            onChange={(e) => {
                                                dispatch(
                                                    updateFormData({
                                                        key: "payment_methods",
                                                        value: e.target.checked
                                                            ? [
                                                                  ...storeData.payment_methods,
                                                                  paymentMethod,
                                                              ]
                                                            : storeData.payment_methods.filter(
                                                                  (method) =>
                                                                      method !==
                                                                      paymentMethod
                                                              ),
                                                    })
                                                );
                                            }}
                                            className="easycommerce-checkbox-input relative pointer checked:bg-ec-primary hidden"
                                        />
                                        <label
                                            htmlFor={paymentMethod}
                                            className="flex items-center space-x-2 cursor-pointer text-ec-body text-[16px]"
                                        >
                                            {Object.keys(
                                                paymentMethodImages
                                            ).includes(paymentMethod) && (
                                                <img
                                                    src={
                                                        paymentMethodImages[
                                                            paymentMethod
                                                        ]
                                                    }
                                                    alt={paymentMethod}
                                                    className="w-[51px]"
                                                />
                                            )}
                                            <span className="capitalize">
                                                {paymentMethod}
                                            </span>
                                        </label>
                                    </div>
                                )
                            )}
                        </div>
                    </div>

                    {/* Pages Information Wrapper */}
                    <div className="border border-ec-border p-6 rounded">
                        <label className="text-ec-body text-[16px] font-medium">
                            Pages
                        </label>
                        <p className="text-ec-placeholder text-xs mt-2">
                            Choose the pages you want to configure.
                        </p>
                        <div className="flex flex-col space-y-4 mt-6">
                            {["shop", "checkout", "dashboard"].map((page) => (
                                <div
                                    key={page}
                                    className="flex flex-col space-y-2"
                                >
                                    <label className="text-ec-body text-[14px] font-medium">
                                        {`${
                                            page.charAt(0).toUpperCase() +
                                            page.slice(1)
                                        } Page`}
                                    </label>
                                    <select
                                        className="easycommerce-wizard-input w-full"
                                        name={page}
                                        value={
                                            page === "checkout"
                                                ? storeData.checkout
                                                : page === "dashboard"
                                                ? storeData.dashboard
                                                : storeData.shop
                                        }
                                        onChange={(e) =>
                                            dispatch(
                                                updateFormData({
                                                    key: page,
                                                    value: e.target.value,
                                                })
                                            )
                                        }
                                    >
                                        <option value="create">
                                            - Create New Page -
                                        </option>
                                        {Object.keys(EASYCOMMERCE.pages).map(
                                            (pageId) => (
                                                <option
                                                    key={pageId}
                                                    value={pageId}
                                                >
                                                    {EASYCOMMERCE.pages[pageId]}
                                                </option>
                                            )
                                        )}
                                    </select>
                                </div>
                            ))}
                        </div>
                    </div>

                    {/* Additional Information Wrapper */}
                    {/* <div className="border border-ec-border p-6 rounded">
                        <label className="text-ec-body text-[16px] font-medium">
                            Demo Products
                        </label>
                        <p className="text-ec-placeholder text-xs mt-2 mb-6">
                            Lorem ipsum dolor sit amet consectetur. Cursus orci
                            eget.
                        </p>
                        <div className="flex flex-col space-y-4">
                            <div className="flex items-center space-x-2">
                                <input
                                    type="checkbox"
                                    id="demoProducts"
                                    checked={storeData.import_demo}
                                    onChange={() =>
                                        dispatch(
                                            updateFormData({
                                                key: "import_demo",
                                                value: !storeData.import_demo,
                                            })
                                        )
                                    }
                                    className="easycommerce-checkbox-input relative pointer checked:bg-ec-primary"
                                />
                                <label
                                    htmlFor="demoProducts"
                                    className="text-ec-secondary text-[16px]"
                                >
                                    I want to Import Demo Product
                                </label>
                            </div>
                        </div>
                    </div> */}
                </div>
            </div>
        </div>
    );
};

export default Store;
